import * as React from 'react';

import {Card} from 'shells/card/card';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';
import {ListView} from 'shells/list-view/list-view';
import {Body} from 'shells/typography/body';

import type {GetFacebookIntegration_facebookIntegration_pages as FacebookPage} from 'nutshell-graphql-types';

type Props = {
    pages: FacebookPage[];
};

export function IntegratedPagesList(props: Props) {
    return (
        <div className='pt-16 flex flex-dir-col gap-8'>
            <Body isBold={true}>Connected pages</Body>
            {props.pages.length > 0 && (
                <Body>
                    The following pages are connected to your Nutshell account. Messages sent to
                    these pages will appear in your inbox.
                </Body>
            )}
            <ListView
                collection={props.pages}
                renderRow={(page) => (
                    <Card hasBorder={true} hasShadow={true}>
                        <div className='flex align-center justify-sb pad-16'>
                            <Body isBold={true}>{page.name}</Body>
                            <Link
                                href={page.link}
                                variant='primary'
                                newTab={true}
                                icon={ExternalLinkIcon}
                                size='small'
                            >
                                View page
                            </Link>
                        </div>
                    </Card>
                )}
                itemSpacing={8}
                emptyStateComponent={
                    <div className='pad-16'>
                        <EmptyStateSmall
                            title='No pages connected'
                            subtitle='Give permission to Nutshell to access your Facebook pages to start receiving messages.'
                            isFlexibleHeight={true}
                            icon={<Illustration src='cactus-empty-state' width={100} />}
                        />
                    </div>
                }
            />
        </div>
    );
}
